/* Hook encargado de hacer la consulta a la base y 
traer el profile a partir de su id

Autor: Benjamín León
Fecha: 2024-09-21
*/
import { useState } from 'react'

import TemplateDto, { TempConsignment, TempFooter } from '../interfaces/TemplateDto.ts'
import { AppPath } from '../enums/AppPath.ts'
import { customFetch } from '../utils/customFetch.ts'

import {
  makeUrlTemplate,
  makeUrlTemplateConFull,
  makeUrlTemplateOrg,
  makeUrlTemplateDocFull,
} from './connectionData.tsx'

const useTemplateFetcher = () => {
  const [errorTemplate, setErrorTemplate] = useState<Error | null>(null)
  const [loadingTemplate, setLoadingTemplate] = useState<boolean>(false)

  const fetchTemplate = async (organizationId: string, docuType: AppPath) => {
    setLoadingTemplate(true)

    try {
      const apiUrl = makeUrlTemplate(organizationId, docuType)
      const data = await customFetch<TemplateDto>(apiUrl)
      setErrorTemplate(null)

      return data
    } catch (err) {
      // Assert the error as an instance of Error
      if (err instanceof Error) {
        setErrorTemplate(err)
      } else {
        setErrorTemplate(new Error('An unknown error occurred'))
      }

      return null
    } finally {
      setLoadingTemplate(false)
    }
  }
  const fetchTemplateOrg = async (organizationId: string) => {
    setLoadingTemplate(true)

    try {
      const apiUrl = makeUrlTemplateOrg(organizationId)
      const data = await customFetch<TemplateDto>(apiUrl)
      setErrorTemplate(null)

      return data
    } catch (err) {
      // Assert the error as an instance of Error
      if (err instanceof Error) {
        setErrorTemplate(err)
      } else {
        setErrorTemplate(new Error('An unknown error occurred'))
      }

      return null
    } finally {
      setLoadingTemplate(false)
    }
  }
  // Para el diseño de la plantilla de Consignacion
  const fetchTemplateConFull = async (organizationId: string) => {
    setLoadingTemplate(true)

    try {
      const apiUrl = makeUrlTemplateConFull(organizationId)
      const data = await customFetch<{ default: TempConsignment; custom: TempConsignment }>(apiUrl)
      setErrorTemplate(null)

      return data
    } catch (err) {
      // Assert the error as an instance of Error
      if (err instanceof Error) {
        setErrorTemplate(err)
      } else {
        setErrorTemplate(new Error('An unknown error occurred'))
      }

      return null
    } finally {
      setLoadingTemplate(false)
    }
  }

  // Para el diseño de la plantilla de Reserva
  const fetchTemplateDocFull = async (organizationId: string, docType: AppPath) => {
    setLoadingTemplate(true)

    try {
      const apiUrl = makeUrlTemplateDocFull(organizationId, docType)
      const data = await customFetch<{ default: TempFooter; custom: TempFooter }>(apiUrl)
      setErrorTemplate(null)

      return data
    } catch (err) {
      // Assert the error as an instance of Error
      if (err instanceof Error) {
        setErrorTemplate(err)
      } else {
        setErrorTemplate(new Error('An unknown error occurred'))
      }

      return null
    } finally {
      setLoadingTemplate(false)
    }
  }

  // Exponemos estas variables al exterior
  return { errorTemplate, loadingTemplate, fetchTemplate, fetchTemplateOrg, fetchTemplateConFull, fetchTemplateDocFull }
}

export default useTemplateFetcher
